import { Trans } from '@lingui/react/macro';
import React from 'react';

import { assertExhaustive } from 'backend-client-web';

import { unlockDeviceTypeForMethods, UnlockMethods } from '../../util/unlockMethods';

export default function UnlockLabel({ unlockMethods }: { unlockMethods: UnlockMethods }) {
  const unlockDeviceType = unlockDeviceTypeForMethods(unlockMethods);

  switch (unlockDeviceType) {
    case 'phone':
      return <Trans>Confirm with your phone</Trans>;
    case 'mobileSafari':
      return <Trans>Confirm access</Trans>;
    case 'multiple':
      return <Trans>Confirm with one of your login devices</Trans>;
    case 'securityKey':
      return <Trans>Confirm with your security key</Trans>;
    default:
      assertExhaustive(unlockDeviceType);
  }
}
